/**
 * Reads admin-controlled marketing image URLs from the SiteContent CMS
 * with a built-in fallback to the hardcoded default. Marketing images live
 * under `marketing_images.{key}` in the site_content doc.
 *
 * Usage:
 *   const heroSrc = useMarketingImage("home.hero", HERO_IMAGE_DEFAULT);
 *
 * Relative URLs (starting with `/api/`) are auto-prefixed with the backend
 * origin so the same value works in dev and prod.
 */
import { useSiteContent } from "@/contexts/SiteContentContext";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const resolveMediaUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${BACKEND}${url}`;
  return url;
};

export const useMarketingImage = (key, fallback) => {
  const { c } = useSiteContent();
  const stored = c(`marketing_images.${key}`, null);
  return resolveMediaUrl(stored || fallback);
};
